/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryMedicinesViewerAliases {
  ACTION_INACTIVATE_HEALTH_HISTORY_MEDICINES = 'action-inactivate-health-history-medicines',
  ACTION_NEW_HEALTH_HISTORY_MEDICINES = 'action-new-health-history-medicines',
  ACTION_REVIEW_HEALTH_HISTORY_MEDICINES = 'action-review-health-history-medicines',
  CHECKBOX_DISPLAY_PATIENT_ALERTS = 'checkbox-display-patient-alerts',
  CHECKBOX_FIRST_TRIMESTER = 'checkbox-first-trimester',
  CHECKBOX_SECOND_TRIMESTER = 'checkbox-second-trimester',
  CHECKBOX_SELF_MEDICATION = 'checkbox-self-medication',
  CHECKBOX_THIRD_TRIMESTER = 'checkbox-third-trimester',
  CHECKBOX_UNKNOWN_END = 'checkbox-unknown-end',
  CHECKBOX_UNKNOWN_INFO_MEDICINE = 'checkbox-unknown-info-medicine',
  CHECKBOX_UNKNOWN_LAST_DOSE = 'checkbox-unknown-last-dose',
  CHECKBOX_UNKNOWN_START = 'checkbox-unknown-start',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_ADM_CHANNEL = 'field-adm-channel',
  FIELD_CONDITION = 'field-condition',
  FIELD_DATE_END = 'field-date-end',
  FIELD_DATE_LAST_DOSE = 'field-date-last-dose',
  FIELD_DATE_START = 'field-date-start',
  FIELD_DATE_TYPE = 'field-date-type',
  FIELD_DISPLAY_PATIENT_ALERTS = 'field-display-patient-alerts',
  FIELD_FIRST_TRIMESTER = 'field-first-trimester',
  FIELD_INTERRUPT_REASON = 'field-interrupt-reason',
  FIELD_INTERVAL = 'field-interval',
  FIELD_JUSTIFICATION_FOR_END = 'field-justification-for-end',
  FIELD_MEDICATION = 'field-medication',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PROVENANCE = 'field-provenance',
  FIELD_QT_DOSE = 'field-qt-dose',
  FIELD_REACTION = 'field-reaction',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_REVIEW_DATE = 'field-review-date',
  FIELD_REVIEW_USERNAME = 'field-review-username',
  FIELD_SCHEDULES = 'field-schedules',
  FIELD_SECOND_TRIMESTER = 'field-second-trimester',
  FIELD_SECURITY_LEVEL = 'field-security-level',
  FIELD_SELF_MEDICATION = 'field-self-medication',
  FIELD_THIRD_TRIMESTER = 'field-third-trimester',
  FIELD_UNITY_MEASURE = 'field-unity-measure',
  FIELD_UNKNOWN_END = 'field-unknown-end',
  FIELD_UNKNOWN_INFO_MEDICINE = 'field-unknown-info-medicine',
  FIELD_UNKNOWN_LAST_DOSE = 'field-unknown-last-dose',
  FIELD_UNKNOWN_START = 'field-unknown-start',
  FIELD_UNREGISTERED_MEDICINE = 'field-unregistered-medicine',
  FORM_HEALTH_HISTORY_MEDICINES_VIEWER = 'form-health-history-medicines-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_HEALTH_HISTORY_MEDICINES = 'layout-health-history-medicines',
  PANEL_FORM = 'panel-form',
  RADIO_GROUP_CONDITION = 'radio-group-condition',
  TEXT_ADM_CHANNEL = 'text-adm-channel',
  TEXT_DATE_END = 'text-date-end',
  TEXT_DATE_LAST_DOSE = 'text-date-last-dose',
  TEXT_DATE_START = 'text-date-start',
  TEXT_DATE_TYPE = 'text-date-type',
  TEXT_INTERRUPT_REASON = 'text-interrupt-reason',
  TEXT_INTERVAL = 'text-interval',
  TEXT_JUSTIFICATION_FOR_END = 'text-justification-for-end',
  TEXT_MEDICATION = 'text-medication',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_PROVENANCE = 'text-provenance',
  TEXT_QT_DOSE = 'text-qt-dose',
  TEXT_REACTION = 'text-reaction',
  TEXT_RECORD_DATE = 'text-record-date',
  TEXT_REVIEW_DATE = 'text-review-date',
  TEXT_REVIEW_USERNAME = 'text-review-username',
  TEXT_SCHEDULES = 'text-schedules',
  TEXT_SECURITY_LEVEL = 'text-security-level',
  TEXT_UNITY_MEASURE = 'text-unity-measure',
  TEXT_UNREGISTRED_MEDICINE = 'text-unregistred-medicine',
}
export { HealthHistoryMedicinesViewerAliases };
